import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

// Import reducers here
import user from './user';
import search from './search';

const rootReducer = combineReducers({
  routing: routerReducer,
  user: user,
  search: search,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js